import { useCallback, useState } from 'react';
import { reportUserAPI } from '../../../api/reports';
import { UserRating, UserReportTypes } from '../../../utils/types';
import { useSnackbar } from 'notistack';
import { voteEventAPI } from '../../../api/events';

export const useVoteEvent = (eventId: string | undefined) => {
    const [isReportLoading, setIsReportLoading] = useState(false);
    const [isVoteLoading, setIsVoteLoading] = useState(false);
    const [error, setError] = useState(null);
    const { enqueueSnackbar } = useSnackbar();

    const reportUser = useCallback(
        async (userId: string, type: UserReportTypes) => {
            if (eventId) {
                try {
                    setIsReportLoading(true);
                    await reportUserAPI(eventId, userId, type);
                } catch (error: any) {
                    console.warn(error);
                    setError(error);
                }

                setIsReportLoading(false);
            }
        },
        [eventId]
    );

    const voteEvent = useCallback(
        async (ratings: UserRating[], winner: string | null) => {
            if (eventId) {
                try {
                    setIsVoteLoading(true);
                    await voteEventAPI(eventId, ratings, winner);

                    enqueueSnackbar('Vote registered.', {
                        variant: 'success',
                    });
                } catch (error: any) {
                    console.warn(error);
                    setError(error);
                }
                setIsVoteLoading(false);
            }
        },
        [eventId, enqueueSnackbar]
    );

    return {
        error,
        reportUser,
        isReportLoading,
        voteEvent,
        isVoteLoading,
    };
};
